import { USERS_ENDPOINT } from "../config";
import { createAnonymousInstance, createInstance } from "./createInstance";
const instance = createInstance(USERS_ENDPOINT);
export const anonymousInstance = createAnonymousInstance(USERS_ENDPOINT);
export default instance;
